module.exports = __webpack_public_path__ + "static/media/illustrationIcon.5a72e0b0.svg";